import React from 'react';

import withAthletesSideModal from './hocs/with-athletes-side-modal';
import {getIconSportUrl, getTagUrl} from './utils/helpers';

const SportsList = ({pathToSportIcons, list, domain, toggleSideModal, withSportImages = true}) => {
  const handleClick = data => () => {
    toggleSideModal({isOpen: true, props: {...data, domain}});
  };

  return (
    <>
      {list.map(sport => (
        <li
          key={sport.id}
          className='block-sports__list-item sports-item'
          onClick={handleClick(sport)}
        >
          <div className='sports-item__wrapper'>
            {withSportImages && (
              <img
                src={getIconSportUrl(sport.id, pathToSportIcons)}
                className='sports-item__icon'
                alt={sport.name}
                loading='lazy'
              />
            )}
            <h3 className='sports-item__title'>{sport.name}</h3>
          </div>
          <svg
            width={20}
            height={20}
            viewBox='0 0 20 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            className='sports-item__icon-next'
          >
            <path d='M8 6L12 10L8 14' stroke='white' strokeWidth='2' />
          </svg>
          <ul className='sports-item__athletes-list'>
            {sport.athletes.map(athlet => (
              <li key={athlet.id}>
                <h4>
                  <a href={getTagUrl(domain, athlet.id)}>{athlet.name}</a>
                </h4>
              </li>
            ))}
          </ul>
        </li>
      ))}
    </>
  );
};

export default withAthletesSideModal(SportsList);
